import { render, staticRenderFns } from "./TwoPackSelectorCard.vue?vue&type=template&id=85bba322"
import script from "./TwoPackSelectorCard.vue?vue&type=script&lang=js"
export * from "./TwoPackSelectorCard.vue?vue&type=script&lang=js"
import style0 from "./TwoPackSelectorCard.vue?vue&type=style&index=0&id=85bba322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports